import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function ObjectDetail() {
  const { slug } = useParams();
  const [o, setO] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/objects/${slug}`).then((r) => setO(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <main className="pt-52 text-center label">Object not found — <Link to="/objects" className="underline">back</Link></main>;
  if (!o) return <main className="pt-52 text-center label">Loading…</main>;

  return (
    <main data-testid="object-detail-page" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-32 md:pt-40 pb-16">
      <div className="border-b hairline pb-5 mb-12">
        <Link to="/objects" className="label hover:opacity-50 transition-opacity" data-testid="back-to-objects">← Objects</Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-8 bg-white border hairline overflow-hidden">
          <img src={o.image} alt={o.label} className="w-full h-auto" />
        </div>
        <aside className="md:col-span-3 md:col-start-10 md:sticky md:top-28 self-start">
          <div className="label mb-3">{o.label}</div>
          <div className="font-display font-700 text-4xl uppercase">{o.title}</div>
          <div className="mt-6 text-[var(--muted)]">{o.year}</div>
          <div className="text-[var(--muted)]">{o.medium}</div>
          {o.description && <p className="mt-8 text-[var(--muted)] leading-relaxed text-sm">{o.description}</p>}
        </aside>
      </div>
    </main>
  );
}
